import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { SIMPLE_PROCESS } from '../../data/content';
import { useLanguage } from '../../i18n/LanguageContext';
export function SimpleProcess() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="w-full bg-mist py-24 lg:py-32" data-id="element-164" data-mp="39ovqsb5c9egu">
      <div className="mx-auto max-w-container px-6" data-id="element-165" data-mp="39o3x55vaxqt7">
        <SectionHeading eyebrow={t.process.eyebrow} title={t.process.title} description={t.process.description} align="center" data-id="element-166" data-mp="3efc4zxgzh449" />

        <ol className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-167" data-mp="30me2lr64ibr7">
          {SIMPLE_PROCESS.map((step, i) => <Reveal as="li" key={step.en} delay={i * 0.05} data-id="element-168" data-mp="2qqb36t2nor7y" data-mpi={i}>
              <div className="group h-full rounded-2xl border border-navy-100 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-lift" data-id="element-169" data-mp="2qqt628jtq3ou">
                <div className="flex items-baseline justify-between" data-id="element-170" data-mp="3hz9w2lr0c128">
                  <span className="font-display text-2xl font-medium text-gold" data-id="element-171" data-mp="3d0yn0d8jdul2">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="h-px w-8 bg-navy-100 transition-colors duration-300 group-hover:bg-gold" aria-hidden="true" data-id="element-172" data-mp="3m2ookbw4u9wk" />
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold leading-snug text-navy" data-id="element-173" data-mp="2ubsbpba2o59a">
                  {step[lang]}
                </h3>
              </div>
            </Reveal>)}
          <Reveal as="li" delay={0.35} data-id="element-174" data-mp="33cgqi87ai9n8">
            <Link to="/how-it-works" className="group flex h-full flex-col justify-between rounded-2xl bg-navy p-6 text-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift" data-id="element-175" data-mp="33bf2z4937uom">
              <span className="eyebrow text-gold" data-id="element-176" data-mp="ekejix7csao5">{t.process.fullDetail}</span>
              <span className="mt-6 inline-flex items-center gap-2 font-display text-lg font-semibold" data-id="element-177" data-mp="eiahylwxfnr1">
                {t.process.seeHow}
                <ArrowRightIcon className="h-4 w-4 text-gold transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-178" data-mp="o9oc0e63zvcs" />
              </span>
            </Link>
          </Reveal>
        </ol>
      </div>
    </section>;
}